import FeedbackIcon from '@mui/icons-material/Feedback';
import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

interface Props {
    listName: string;
    listId: number;
}

export default function GroupContactsNotFound({ listName, listId }: Props) {
    const { classes } = useStyles();

    return (
        <Grid
            container
            direction="column"
            wrap="nowrap"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            className={classes.root}
        >
            <Grid item xs="auto">
                <FeedbackIcon className={classes.icon} />
            </Grid>
            <Grid item xs="auto">
                <Typography component="p" variant="h5" align="center">
                    {`There is no contact to display on ${listName} ${
                        listId >= -1 ? (listId === -1 ? '' : 'group') : 'segment'
                    }.`}
                </Typography>
            </Grid>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
        padding: theme.spacing(0.5),
    },
    icon: {
        color: '#6f52ed',
        fontSize: '4rem',
    },
}));
